// extracted by mini-css-extract-plugin
var _1 = "ApplicantFitCheckBlock-modulebody__MRddr";
var _2 = "ApplicantFitCheckBlock-modulecolumnTitle__kjL9J";
var _3 = "ApplicantFitCheckBlock-modulecriteria__i_BjB";
var _4 = "ApplicantFitCheckBlock-moduleheaderRule__GzYuC";
var _5 = "ApplicantFitCheckBlock-modulehintIcon__eSejc IconNG-moduleiconContainer__SxWZ0";
var _6 = "ApplicantFitCheckBlock-modulescore__ba5JZ";
var _7 = "ApplicantFitCheckBlock-modulestale__ks94J";
var _8 = "ApplicantFitCheckBlock-moduleunavailable__VhAvd";
export { _1 as "body", _2 as "columnTitle", _3 as "criteria", _4 as "headerRule", _5 as "hintIcon", _6 as "score", _7 as "stale", _8 as "unavailable" }
